import { getObjectSettingsByType } from 'src/endpoints'

import { NewStructureDto, ObjectSettingsComboDto } from '@/endpoints/models'
import { apiCallAction, thunkAction } from '@/store/utils'

export const OBJECT_SETTINGS_BY_TYPE = 'OBJECT_SETTINGS_BY_TYPE'

interface LoadObjectSettingsByType {
	metadata: {
		type: NewStructureDto.TypeEnum
	},
	payload: ObjectSettingsComboDto[]
	type: typeof OBJECT_SETTINGS_BY_TYPE
}

export const getDefaultObjectSettings = (type: NewStructureDto.TypeEnum) =>
	thunkAction(async dispatch => {
		const objectSettings = await dispatch(
			apiCallAction<LoadObjectSettingsByType>(
				() => getObjectSettingsByType(type),
				OBJECT_SETTINGS_BY_TYPE,
				{ type }
			)
		)

		const defaultOs = objectSettings?.find(os => os.defaultFlag)

		if (defaultOs) {
			return { id: defaultOs.id, code: defaultOs.code, name: defaultOs.name }
		}
	})
